/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Minimumoutsideairdamperssetpoint4Inputs */



/**
* | output |
* | --- |
* | "Fresh air damper setpoint" |
*
* @param {Ahu_History_Key_Minimumoutsideairdamperssetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_minimumoutsideairdamperssetpoint4 = /** @type {((inputs?: Ahu_History_Key_Minimumoutsideairdamperssetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Minimumoutsideairdamperssetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air damper setpoint")
	return /** @type {LocalizedString} */ ("Consigne volet air neuf")
});
export { ahu_history_key_minimumoutsideairdamperssetpoint4 as "ahu_history_key_minimumOutsideAirDampersSetpoint" }